import { Mutation } from 'vuex';
import { IModuleState } from '@/store/common/types';

// App 组件里 toast
export const setToast: Mutation<IModuleState> = (state, payload) => {
  const timeout = parseInt(payload.timeout, 10);
  state.toast.visible = !!payload.visible;
  state.toast.text = payload.text || '';
  state.toast.timeout = isNaN(timeout) ? 2000 : timeout;
};

// App 组件里 img-view
export const setImgView: Mutation<IModuleState> = (state, payload) => {
  state.imgView.visible = !!payload.visible;
  state.imgView.src = payload.src || '';
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
